import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import {
  CONSENT_UPDATED_EVENT,
  hasMapsConsent,
} from "@/lib/cookieConsent";

const MAP_EMBED_SRC =
  "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11724.936859385967!2d12.2126753!3d43.1441941!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132c03b77e5a02cd%3A0x28d3d21dfae7e3ff!2snegozio%20prodotti%20zootecnici%20pietro%20rubini!5e0!3m2!1sit!2sit!4v1234567890";

const ContactSection = () => {
  // La mappa Google (terza parte) viene caricata solo dopo consenso esplicito:
  // click sul placeholder o consenso "maps" gia' salvato nelle preferenze cookie.
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    if (hasMapsConsent()) {
      setShowMap(true);
    }
    const onConsentUpdate = () => {
      if (hasMapsConsent()) setShowMap(true);
    };
    window.addEventListener(CONSENT_UPDATED_EVENT, onConsentUpdate);
    return () =>
      window.removeEventListener(CONSENT_UPDATED_EVENT, onConsentUpdate);
  }, []);

  return (
    <section id="contatti" className="py-4 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 animate-fade-in-up">
          <h2 className="mb-4 text-primary uppercase text-2xl md:text-4xl text-center" style={{ fontFamily: 'Verdana, sans-serif' }}>Vieni a trovarci</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto" style={{ fontFamily: 'Verdana, sans-serif' }}>
            Siamo a Magione, in Viale Umbria 21. Ti aspettiamo!
          </p>
        </div>

        <div className="max-w-4xl mx-auto animate-fade-in-up">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-large)] h-[500px] lg:h-[600px]">
            {showMap ? (
              <iframe
                src={MAP_EMBED_SRC}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mappa Mangimi Rubini"
              />
            ) : (
              // Placeholder self-hosted: nessuna richiesta a Google finche' l'utente non acconsente.
              <div className="w-full h-full bg-muted flex flex-col items-center justify-center text-center px-6 py-8">
                <MapPin className="w-12 h-12 text-primary mb-4" aria-hidden="true" />
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  Mappa Google
                </h3>
                <p className="text-sm text-muted-foreground max-w-md mb-6">
                  Caricando la mappa accetti che Google Maps imposti cookie e
                  riceva il tuo indirizzo IP. Consulta la{" "}
                  <a href="/cookie-policy" className="underline hover:text-foreground">
                    Cookie Policy
                  </a>{" "}
                  e la{" "}
                  <a href="/privacy-policy" className="underline hover:text-foreground">
                    Privacy Policy
                  </a>
                  .
                </p>
                <button
                  type="button"
                  onClick={() => setShowMap(true)}
                  className="btn-cta px-6 py-3 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all"
                >
                  Carica mappa Google
                </button>
              </div>
            )}
          </div>

          {/* Navigation Button */}
          <div className="mt-6 text-center">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Viale+Umbria+21,+06063+Magione+PG"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block btn-cta px-8 py-4 rounded-xl font-semibold text-lg shadow-md hover:shadow-lg transition-all"
            >
              Imposta Navigatore
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
